import { render, staticRenderFns } from "./form-settlement.vue?vue&type=template&id=4500962a&scoped=true"
import script from "./form-settlement.vue?vue&type=script&lang=js"
export * from "./form-settlement.vue?vue&type=script&lang=js"
import style0 from "./form-settlement.vue?vue&type=style&index=0&id=4500962a&prod&lang=css"
import style1 from "./form-settlement.vue?vue&type=style&index=1&id=4500962a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500962a",
  null
  
)

export default component.exports